<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="container auth" [zeroLoadingIndicator]="ongoingRequest">
  <div class="row mt-5">
    <div class="col-12">
      <div class="mt-5 mb-5">
        <svg width="204" height="66" viewBox="0 0 204 66" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="5.225%" y1="30.006%" x2="26.572%" y2="86.613%" id="zdgy2isy8a">
              <stop stop-color="#E81673" offset="0%" />
              <stop stop-color="#2C8BF1" offset="100%" />
            </linearGradient>
          </defs>
          <g fill-rule="nonzero" fill="none">
            <path
              d="M65.951 20.722v-5.814A14.932 14.932 0 0 0 61.583 4.37 14.907 14.907 0 0 0 51.055 0H14.896A14.908 14.908 0 0 0 4.368 4.371 14.931 14.931 0 0 0 0 14.908v20.78l7.292-3.616V14.908a7.62 7.62 0 0 1 7.604-7.61h36.159a7.608 7.608 0 0 1 5.374 2.232 7.62 7.62 0 0 1 2.229 5.378v1.285L0 45.279v5.813A14.93 14.93 0 0 0 4.367 61.63 14.909 14.909 0 0 0 14.897 66h36.158a14.907 14.907 0 0 0 10.528-4.371 14.93 14.93 0 0 0 4.368-10.537V30.32l-7.293 3.616v17.163a7.62 7.62 0 0 1-2.23 5.378 7.609 7.609 0 0 1-5.373 2.232H14.896a7.611 7.611 0 0 1-5.374-2.232 7.62 7.62 0 0 1-2.23-5.378v-1.284l58.66-29.092z"
              fill="url(#zdgy2isy8a)"
            />
            <path
              fill="#FFF"
              d="m85.304 57.637 20.016-24.594 3.54-3.952-5.379.068H85.1v-2.93h27.572v2.658L93.27 52.868l-4.084 4.565 6.127-.068h18.177v2.93H85.304zM146.586 42.445c0 .772-.045 1.521-.136 2.248h-27.028c.227 4.178 1.452 7.449 3.676 9.81 2.27 2.317 5.288 3.475 9.055 3.475 2.678 0 4.97-.545 6.876-1.635 1.952-1.09 3.359-2.634 4.22-4.633l2.86 1.499c-1.27 2.498-3.086 4.428-5.446 5.79-2.36 1.318-5.197 1.977-8.51 1.977-5.038 0-8.987-1.567-11.846-4.701-2.814-3.134-4.221-7.472-4.221-13.013 0-5.541 1.361-9.879 4.085-13.013 2.768-3.134 6.626-4.7 11.573-4.7 4.63 0 8.26 1.544 10.893 4.632 2.633 3.089 3.949 7.177 3.949 12.264zm-14.842-13.899c-3.676 0-6.58 1.158-8.714 3.475-2.133 2.27-3.336 5.473-3.608 9.606h23.964c-.227-4.088-1.362-7.29-3.404-9.606-1.997-2.317-4.743-3.475-8.238-3.475zM167.187 25.548c1.815 0 3.245.386 4.289 1.159l-.885 3.202c-1.044-.818-2.497-1.227-4.358-1.227-1.724 0-3.358.545-4.901 1.636-1.498 1.044-2.724 2.543-3.677 4.496-.907 1.908-1.361 4.042-1.361 6.404v19.076h-3.404V26.23h2.86l.408 6.949c.953-2.407 2.36-4.27 4.22-5.587 1.907-1.362 4.176-2.044 6.809-2.044zM187.578 25.548c5.038 0 8.986 1.59 11.846 4.77 2.904 3.133 4.357 7.448 4.357 12.944s-1.453 9.833-4.357 13.013c-2.86 3.134-6.808 4.7-11.846 4.7s-9.01-1.566-11.914-4.7c-2.86-3.18-4.29-7.517-4.29-13.013 0-5.496 1.43-9.81 4.29-12.944 2.904-3.18 6.876-4.77 11.914-4.77zm0 2.93c-3.994 0-7.126 1.317-9.395 3.952-2.27 2.634-3.404 6.245-3.404 10.832 0 4.588 1.134 8.198 3.404 10.833 2.27 2.634 5.4 3.951 9.395 3.951 3.994 0 7.125-1.317 9.395-3.951 2.27-2.635 3.404-6.245 3.404-10.833 0-4.587-1.135-8.198-3.404-10.832-2.27-2.635-5.401-3.952-9.395-3.952zM86.808 6.21v4.494h5.584v.829h-5.584v5.5h-.88V5.398h7.926v.81zM96.918 17.032h-.88V5.4h.88zM109.333 17.032h-1.092l-6.165-9.13-.863-1.552h-.018l.053 1.463v9.22h-.845V5.398h1.11l6.147 9.113.88 1.568-.035-1.463V5.4h.828zM119.265 13.384h-5.566l-1.445 3.648h-.933L115.97 5.4h1.039l4.65 11.633h-.933l-1.462-3.648zm-.317-.811-2.026-5.077-.423-1.234h-.017l-.423 1.199-2.026 5.112h4.915zM132.58 17.032h-1.091l-6.165-9.13-.863-1.552h-.018l.053 1.463v9.22h-.845V5.398h1.11l6.147 9.113.88 1.568-.035-1.463V5.4h.828zM143.975 16.221v.811h-8.984v-.775l7.663-10.048h-7.504V5.4h8.543v.775l-7.662 10.047zM154.557 16.221v.811h-8.226V5.4h7.944v.81h-7.063v4.495h5.583v.829h-5.583v4.688zM165.87 17.032h-1.092l-6.165-9.13-.863-1.552h-.017l.053 1.463v9.22h-.846V5.398h1.11l6.147 9.113.88 1.568-.035-1.463V5.4h.828zM169.46 15.587a.73.73 0 0 1 .564.23.73.73 0 0 1 .23.563.788.788 0 0 1-.23.582c-.14.14-.328.211-.563.211a.823.823 0 0 1-.581-.211.824.824 0 0 1-.212-.582c0-.235.07-.423.212-.564a.787.787 0 0 1 .58-.23zM181.98 17.032h-1.092l-6.165-9.13-.863-1.552h-.018l.053 1.463v9.22h-.846V5.398h1.11l6.147 9.113.881 1.568-.035-1.463V5.4h.828zM193.69 16.221v.811h-8.225V5.4h7.944v.81h-7.064v4.495h5.584v.829h-5.584v4.688zM204 6.21h-4.245v10.822h-.88V6.21h-4.246V5.4H204z"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      @if (!isNewPasswordRequired()) {
        <h1 class="zero-text p-huge-lig mb-4">{{ 'login.default.greeting' | transloco }}</h1>
        @if (signupConfirmation) {
          <div class="row mb-3">
            <div class="col-12">
              <ng-container *ngIf="!confirmationState">Deine E-Mail-Bestätigung wird überprüft ...</ng-container>
              @switch (confirmationState) {
                @case ('valid') {
                  <span class="text-success">
                    Deine E-Mail-Adresse wurde bestätigt!<br />
                    Logge Dich bitte ein, um mit der Depoteröffnung fortzufahren.
                  </span>
                }
                @case ('invalid') {
                  <span class="text-danger">
                    Deine E-Mail-Adresse konnte aufgrund eines Fehlers nicht bestätigt werden. Eventuell ist Dein Code auch abgelaufen. Aus
                    Sicherheitsgründen ist der Code zur Bestätigung Deiner E-Mail Adresse lediglich 24 Stunden lang gültig.
                    <a [routerLink]="commonRoutes.prelogin.onboarding.resendConfirmationMail" class="link link-underline text-nowrap">
                      Fordere hier einen neuen Code an
                    </a>
                  </span>
                }
                @case ('not-acceptable') {
                  <span class="text-danger">{{ confirmationErrorMessage }}</span>
                }
              }
            </div>
          </div>
        }
        <form novalidate (ngSubmit)="login(loginForm)" #loginForm="ngForm" autocomplete="off">
          <div class="row">
            <div class="col-lg-11 mb-3">
              <div class="input-group-material">
                <input
                  spellcheck="false"
                  id="userNameId"
                  type="text"
                  data-zid="usr"
                  [placeholder]="'login.default.usernamePlaceholder' | transloco"
                  required
                  [zeroEmailOrUser]="validatedAtLeastOnce || userNameVar.touched"
                  [(ngModel)]="userName"
                  name="userName"
                  #userNameVar="ngModel"
                  autocomplete="off"
                  [class.empty]="!userNameVar.value"
                />
                <div class="input-group-material-icon-state"></div>
                @if ((userNameVar.errors && userNameVar.errors['required']) || userNameVar.valid) {
                  <div class="input-group-material-message">&nbsp;</div>
                }
                @if (
                  userNameVar.errors &&
                  userNameVar.errors['emailOrUser'] &&
                  userNameVar.invalid &&
                  ((userNameVar.touched && userNameVar.dirty) || validatedAtLeastOnce)
                ) {
                  <div class="input-group-material-message" data-zid="input-message-email">
                    {{ 'login.default.error.frontendValidationUsername' | transloco }}
                  </div>
                }
              </div>
            </div>
            <div class="col-lg-11 mb-3">
              <div class="input-group-material">
                <input
                  id="passwordId"
                  type="password"
                  required="required"
                  [placeholder]="'login.default.passwordPlaceholder' | transloco"
                  [(ngModel)]="password"
                  name="password"
                  data-zid="pass"
                  #passwordVar="ngModel"
                  [pattern]="validatedAtLeastOnce || passwordVar.touched ? passwordPattern : undefined"
                  autocomplete="off"
                  [class.empty]="!passwordVar.value"
                />
                <div class="input-group-material-icon-state"></div>
                @if ((passwordVar.errors && passwordVar.errors['required']) || passwordVar.valid) {
                  <div class="input-group-material-message">&nbsp;</div>
                }
                @if (
                  passwordVar.errors &&
                  passwordVar.errors['pattern'] &&
                  passwordVar.invalid &&
                  ((passwordVar.touched && passwordVar.dirty) || validatedAtLeastOnce)
                ) {
                  <div
                    class="input-group-material-message"
                    data-zid="input-message-pass"
                    [innerHTML]="'login.default.error.frontendValidationPassword' | transloco"
                  ></div>
                }
              </div>
            </div>
            <div class="col-lg-11">
              <div class="row align-items-center">
                <div class="col-12 mb-4">
                  <web-design-system-button
                    type="gold"
                    data-zid="login"
                    [isSubmit]="true"
                    [fullwidth]="true"
                    [disabled]="maintenanceService.isLoginDisabled$ | async"
                  >
                    {{ 'login.default.submit' | transloco }}
                  </web-design-system-button>
                </div>
                <div class="col-sm-5 col-md-12 col-xl-5">
                  <a [routerLink]="commonRoutes.prelogin.forgot_pwd" data-zid="forgot-password">
                    {{ 'login.default.forgotPassword' | transloco }}
                  </a>
                </div>
                <div class="col-sm-7 col-md-12 col-xl-7 text-sm-right text-md-left text-xl-right">
                  {{ 'login.default.registerPrefix' | transloco }}
                  <a [routerLink]="commonRoutes.prelogin.onboarding.signUp" data-zid="become-customer">
                    {{ 'login.default.register' | transloco }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
      }

      @if (isNewPasswordRequired()) {
        <div class="row">
          <div class="col-lg-11">
            <h1 class="font-light mb-4">Initiales Passwort</h1>
            <p>Du musst Dein initiales Passwort ändern.</p>
          </div>
        </div>
        <form (ngSubmit)="setNewPassword(newPWForm)" #newPWForm="ngForm">
          <div class="row">
            <div class="col-lg-11">
              <div class="input-group-material">
                <input
                  id="inputNewPassword"
                  type="password"
                  required="required"
                  placeholder="Passwort"
                  ngModel
                  name="inputNewPassword"
                  #inputNewPassword="ngModel"
                  [pattern]="passwordPattern"
                  autocomplete="off"
                  [class.empty]="!inputNewPassword.value"
                />
                <div class="input-group-material-icon-state"></div>
                @if (inputNewPassword.errors && inputNewPassword.errors['required']) {
                  <div class="input-group-material-message">Bitte Passwort eingeben.</div>
                }
                @if (inputNewPassword.errors && inputNewPassword.errors['pattern'] && inputNewPassword.dirty) {
                  <div class="input-group-material-message">
                    Mindestens 8 Zeichen bestehend aus Groß-&nbsp;/ Klein&shy;buch&shy;staben, Ziffern und Sonder&shy;zeichen.
                  </div>
                }
                @if (inputNewPassword.valid) {
                  <div class="input-group-material-message">&nbsp;</div>
                }
              </div>
            </div>
            <div class="col-lg-11">
              <web-design-system-button [isSubmit]="true" type="gold" [fullwidth]="true" [disabled]="newPWForm.invalid"
                >Absenden</web-design-system-button
              >
            </div>
          </div>
          <div class="row justify-content-center mt-4"></div>
        </form>
      }

      <div class="row mt-3">
        <div class="col-lg-11">
          <web-components-user-messages data-zid="login-user-messages" [showLatestOnly]="true" />
        </div>
      </div>

      <div class="row mt-3">
        @if (!signupConfirmation) {
          <div class="col-12" data-nosnippet>
            <web-components-user-notes target="loginpage" wrapperDivClasses="mt-2 mb-5" />
            <div class="mt-4 mb-5">
              <h5 class="font-size-smaller1 font-medium">{{ 'login.default.securityInfo.header' | transloco }}</h5>
              <p class="font-size-smaller1 mt-2">
                {{ 'login.default.securityInfo.message1' | transloco }}
                <br />
                {{ 'login.default.securityInfo.message2' | transloco }}
                <a
                  href="https://www.finanzen.net/zero/sicherheitshinweise/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link link-underline"
                  >{{ 'login.default.securityInfo.message2LinkTitle' | transloco }}</a
                >{{ 'login.default.securityInfo.message3' | transloco }}
              </p>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="col-lg-6 d-lg-flex align-items-start justify-content-end">
      <web-components-login-info-cards />
    </div>
  </div>
</div>
<web-components-slim-footer class="slim-footer dark justify-content-start" [hideLogout]="true" />
